//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";

//
// Component
//

export function initialiseLinkHierarchySidebar(linkHierarchySidebar: HTMLElement)
{
	const mobileToggle = BrowserUtilities.ElementClientLib.getElementOrThrow(linkHierarchySidebar, ".mobile-toggle button");

	const sidebarWrapper = BrowserUtilities.ElementClientLib.getElementOrThrow(linkHierarchySidebar, ".sidebar-wrapper");

	mobileToggle.addEventListener("click", 
		() =>
		{
			sidebarWrapper.classList.toggle("mobile-open");
		});

	linkHierarchySidebar.classList.add("initialised");
}

export function initialiseLinkHierarchySidebars()
{
	const linkHierarchySidebars = document.querySelectorAll<HTMLElement>(".component-link-hierarchy-sidebar:not(.initialised)");

	console.log("[LinkHierarchySidebar] Initialising " + linkHierarchySidebars.length + " instances...");

	for (const linkHierarchySidebar of linkHierarchySidebars)
	{
		try
		{
			initialiseLinkHierarchySidebar(linkHierarchySidebar);
		}
		catch (error)
		{
			console.error("[LinkHierarchySidebar] Error initialising:", linkHierarchySidebar, error);
		}
	}
}